import React from "react"
import FloatingActionButton from "material-ui/FloatingActionButton"
import ContentAdd from "material-ui/svg-icons/content/add"
import AddAccountRoleDialog from "./AddAccountRoleDialog"
import autobind from "class-autobind"
import AccountStore from "../../../stores/AccountStore"
import AppStateStore from "../../../stores/AppStateStore"
import AccountRolesTableRowExtendPanel from "./AccountRolesTableRowExtendPanel"
import TableActionBar from "../../../components/layout/TableActionBar"
import strings from "../../../localization/strings"
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import * as accountActions from "../../../actions/AccountActions"
import * as permissionHelper from "../../../helpers/permissionHelper"
import { IUserRole } from "../../../models"
interface IProps {

}
interface IState {
	userRoles: IUserRole[]
	openAddDialog: boolean
	searchText: string
	extendedRoleIds: string[]
	editRole: IUserRole
	selectedRole: IUserRole
}

export default class AccountRolesTab extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props)
		this.state = {
			userRoles: AccountStore.getCurrentAccountSettings().UserRoles || [],
			openAddDialog: false,
			searchText: "",
			extendedRoleIds: [],
			editRole: null,
			selectedRole: null,
		}
		autobind(this)
	}

	componentDidMount() {
		AccountStore.on("account_change", this.changeEvent)
	}

	componentWillUnmount() {
		AccountStore.removeListener("account_change", this.changeEvent)
	}

	changeEvent() {
		this.setState({ userRoles: AccountStore.getCurrentAccountSettings().UserRoles || [] })
	}

	handleSaveRole(role, permissionCheckBox = false) {
		this.setState({ openAddDialog: false, editRole: null })
		AppStateStore.setProgressSnackbarContent(permissionCheckBox ? "" : "loading")
		const accountUserRoles = AccountStore.getCurrentAccountSettings().UserRoles !== null ? AccountStore.getCurrentAccountSettings().UserRoles : []
		const editedRole = accountUserRoles.find((item) => item.Id === role.Id)
		if (editedRole) {
			accountUserRoles.forEach((item) => {
				if (item.Id === role.Id) {
					item.Type = role.Type
					item.Permissions = role.Permissions
				}
			})
		} else {
			accountUserRoles.push(role)
		}
		accountActions.patchAccount(AccountStore.getCurrentAccount().Id, { AccountSettings: { UserRoles: accountUserRoles } },
			() => !permissionCheckBox &&
				AppStateStore.setProgressSnackbarContent(editedRole ? strings.UserRole_updated_successfully : strings.UserRole_added_successfully)
		)
	}

	deleteRole() {
		const { selectedRole } = this.state
		const accountUsers = AccountStore.getUsers()
		if (accountUsers.filter((user) => user.UserRoleId === selectedRole.Id).length > 0) {
			AppStateStore.setProgressSnackbarContent(strings.Cannot_this_UserRole)
			this.setState({ selectedRole: null })
		} else {
			AppStateStore.setProgressSnackbarContent("loading")
			const accountUserRoles = AccountStore.getCurrentAccountSettings().UserRoles.filter((role) => role.Id !== selectedRole.Id)
			accountActions.patchAccount(AccountStore.getCurrentAccount().Id, { AccountSettings: { UserRoles: accountUserRoles } }, res => {
				AppStateStore.setProgressSnackbarContent(res === "fail" ? strings.Failed_to_remove_UserRole : strings.UserRole_removed_successfully)
				this.setState({ selectedRole: null })
			})
		}
	}

	render() {
		const filteredRoles = this.state.userRoles.filter((item) => (this.state.searchText ? item.Type.toLowerCase().includes(this.state.searchText.toLowerCase()) : true))
		return (
			<div className="AccountRolesTab">
				<FloatingActionButton
					data-intercom-target={"menu-AccountUsers-Roles-Btn-Add"}
					className="fixed-add"
					style={{ top: -28, right: 20, zIndex: 500 }}
					secondary={true}
					onTouchTap={() => this.setState({ openAddDialog: true })}
				>
					<ContentAdd />
				</FloatingActionButton>
				<div style={{ padding: 30 }}>
					<TableActionBar
						onSearch={searchText => this.setState({ searchText, selectedRole: null })}
						searchText={this.state.searchText}
						rowSelectionCount={this.state.selectedRole ? 1 : 0}
						onCloseSearchClick={() => this.setState({ searchText: "", selectedRole: null })}
						multipleSelectedMessage={strings.x_Roles_Selected}
						singleSelectedMessage={strings.Role_Selected}
						title={strings.User_Roles}
						titleStyle={{ fontSize: 20, fontWeight: 600 }}
						onDeleteClick={() =>
							AppStateStore.setConfirmDialogContent({
								content: strings.Are_you_sure_you_want_to_delete_selected_Role,
								confirm: () => this.deleteRole()
							})
						}
					/>
					<div style={{ minHeight: 500 }}>
						{filteredRoles.length === 0 ?
							<div style={{ textAlign: "center", fontSize: 30, fontWeight: "bold", marginTop: 30 }}>
								{strings.No_User_Role}
							</div> :
							<Table
								selectable
								multiSelectable={false}
								onCellClick={(rowNumber, columnId) => {
									const clickedRole = filteredRoles[rowNumber]
									columnId === -1 &&
										this.setState({
											selectedRole: this.state.selectedRole && this.state.selectedRole.Id === clickedRole.Id ? null : clickedRole
										})
								}}
							>
								<TableHeader displaySelectAll={false} enableSelectAll={false}>
									<TableRow className="ShortSelectBoxTableHeader">
										<TableHeaderColumn style={styles.nameCol}>{strings.Name}</TableHeaderColumn>
										<TableHeaderColumn>{strings.Permissions}</TableHeaderColumn>
										<TableHeaderColumn style={styles.expandIconCol} />
									</TableRow>
								</TableHeader>
								<TableBody deselectOnClickaway={false}>
									{filteredRoles.map((role, index) => {
										const selected = this.state.selectedRole && this.state.selectedRole.Id === role.Id ? true : false
										return (
											<TableRow data-intercom-target={index === 0 && "menu-AccountUsers-Roles-openItemEditDialog"} key={index} className="ShortSelectBoxTableRow" selected={selected}>
												<TableRowColumn style={{ paddingLeft: 0, paddingRight: 0 }}>
													<Table
														style={{ backgroundColor: "none" }}
														onCellClick={(rowNumber, columnId) => {
															if ((columnId === 0 || columnId === 1) && rowNumber === 0) {
																this.setState({ selectedRole: null, openAddDialog: true, editRole: role })
															}
															else if (columnId === 2) {
																const extendedRoleIds = this.state.extendedRoleIds
																extendedRoleIds.includes(role.Id) ? extendedRoleIds.splice(extendedRoleIds.indexOf(role.Id), 1) : extendedRoleIds.push(role.Id)
																this.setState({ extendedRoleIds })
															}
														}}
													>
														<TableBody displayRowCheckbox={false}>
															<TableRow style={{ cursor: "pointer", height: 48, borderBottom: "none" }}>
																<TableRowColumn style={styles.nameCol}>{role.Type}</TableRowColumn>
																<TableRowColumn>
																	{role.Permissions ? role.Permissions.length : "0"} {strings.Permissions}
																</TableRowColumn>
																<TableRowColumn style={styles.expandIconCol}>
																	<i
																		data-intercom-target={index === 0 && "menu-AccountUsers-Roles-expandItemDetail"}
																		className={this.state.extendedRoleIds.includes(role.Id) ? "fa fa-chevron-up" : "fa fa-chevron-down"}
																		style={{ fontSize: 18 }}
																	/>
																</TableRowColumn>
															</TableRow>
															{this.state.extendedRoleIds.includes(role.Id) &&
																<TableRow>
																	<TableRowColumn
																		colSpan={3}
																		style={{ paddingRight: 0, paddingLeft: 0 }}
																	>
																		<div onClick={(e) => e.stopPropagation()} style={{ overflow: "auto" }}>
																			<AccountRolesTableRowExtendPanel
																				role={role}
																				selected={selected}
																				saveRole={this.handleSaveRole}
																			/>
																		</div>
																	</TableRowColumn>
																</TableRow>
															}
														</TableBody>
													</Table>
												</TableRowColumn>
											</TableRow>
										)
									})}
								</TableBody>
							</Table>
						}
					</div>
				</div>
				{this.state.openAddDialog &&
					<AddAccountRoleDialog
						open={this.state.openAddDialog}
						editRole={this.state.editRole}
						handleClose={() => this.setState({ openAddDialog: false, editRole: null })}
						handleSave={this.handleSaveRole}
					/>
				}
			</div>
		)
	}
}

const styles = {
	nameCol: {
		width: 150,
		paddingLeft: 0,
		paddingRight: 10
	},
	expandIconCol: {
		width: 30,
		paddingLeft: 10,
		paddingRight: 10
	}
}